/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import api from '@redux/apis/baseApi'
import { transformResponseWithHttpStatus } from '@redux/apis/sharedUtils'
import {
  API_GCP_OIDC_PATH,
  API_CLOUD_ACCOUNT_PATH,
  API_OIDC_DOWNLOAD_TERRAFORM_GCP_TEMPLATE,
} from '@constants/api'

const CACHE_NAMES = ['OIDC'] as const

const oidcApi = api.injectEndpoints({
  endpoints: build => ({
    getGCPProject: build.query<
      Response.CustomResponse<Response.OIDC.DescribeGCPProject>,
      string
    >({
      query: projectID => ({
        url: `${API_GCP_OIDC_PATH}/${projectID}`,
        service: API_CLOUD_ACCOUNT_PATH,
      }),
      transformResponse:
        transformResponseWithHttpStatus<Response.OIDC.DescribeGCPProject>,
    }),
    getGCPDeploymentTerraformTemplate: build.query<string, void>({
      query: () => ({
        url: API_OIDC_DOWNLOAD_TERRAFORM_GCP_TEMPLATE,
        headers: {
          'content-type': 'text/plain',
        },
        responseHandler: response => response.text(),
        service: API_CLOUD_ACCOUNT_PATH,
      }),
    }),
    postGCPCloudAccountOIDC: build.mutation<
      Response.CustomResponse<Response.OIDC.DescribeGCPProject>,
      Request.PostGCPCloudAccountOIDCPayload
    >({
      query(body) {
        return {
          url: `${API_CLOUD_ACCOUNT_PATH}/gcp`,
          method: 'POST',
          body,
          service: API_CLOUD_ACCOUNT_PATH,
        }
      },
      transformResponse:
        transformResponseWithHttpStatus<Response.OIDC.DescribeGCPProject>,
    }),
  }),
})

oidcApi.enhanceEndpoints({
  addTagTypes: CACHE_NAMES,
  endpoints: {
    getGCPDeploymentTerraformTemplate: {
      providesTags: CACHE_NAMES,
    },
    getGCPProject: {
      providesTags: CACHE_NAMES,
      extraOptions: { maxRetries: 0 },
    },
    postGCPCloudAccountOIDC: {
      extraOptions: { maxRetries: 0 },
    },
  },
})

export default oidcApi
